<div class="skill-table">
  <p-table
    [columns]="teams"
    [scrollable]="true"
    [value]="skills"
    [autoLayout]="true"
  >
    <ng-template pTemplate="header" let-columns>
      <tr pFrozenColumn alignFrozen="top">
        <th pSortableColumn="g_name" alignFrozen="left" pFrozenColumn>
          Group
          <p-sortIcon field="g_name"/>
        </th>
        <th pSortableColumn="skill_name" alignFrozen="left" pFrozenColumn>
          Skill
          <p-sortIcon field="skill_name"/>
        </th>
        <th pSortableColumn="usedByCount" alignFrozen="left" pFrozenColumn>
          Count
        <p-sortIcon field="usedByCount"/>
        </th>

        @for (col of columns; track col) {
          <th style="min-width: 168px; max-width: 168px">
            {{ col }}
          </th>
        }
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-columns="columns" let-rowData>
      <tr>
        <td  alignFrozen="left" pFrozenColumn>
          <div class="align-items-center flex gap-3 hstack">
            <div class="hstack">
              <div class="cell-team">{{ rowData["g_name"] }}</div>
            </div>
          </div>
        </td>
        <td  alignFrozen="left" pFrozenColumn>
          <div class="align-items-center flex gap-3 hstack">
            <div class="hstack">
              <div class="cell-username">{{ rowData["skill_name"] }}</div>
            </div>
          </div>
        </td>
        <td  alignFrozen="left" pFrozenColumn>
          <div class="align-items-center flex gap-3 hstack">
            <div class="hstack">
              <div class="cell-usedby">
                {{ rowData['usedByCount'] }}
              </div>
            </div>
          </div>
        </td>

        @for (col of columns; track col) {
          <td class="no-wrapped" style="min-width: 168px; max-width: 168px">
            <div class="field-checkbox mb-0 justify-content-center">
              <input
                type="checkbox"
                class="checkbox checkbox--skillteam"
                [(ngModel)]="rowData[col]"
                (change)="onSkillToggle(rowData, col, getChecked($event))"
              />
            </div>
          </td>
        }

      </tr>
    </ng-template>
  </p-table>
</div>
